var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Dialog, DialogHeader, DialogContent, Stacker, Styler, TypographyBody } from '@honeycomb/ui-core';
import { useGlobalContext } from '@honeycomb/data';
export function SkywardsDialog(_a) {
    var { skywardsText } = _a, other = __rest(_a, ["skywardsText"]);
    const { resourceStrings: { EMIRATESAIRMILESDIALOGTITLE }, } = useGlobalContext();
    return (React.createElement(Dialog, Object.assign({ size: "l" }, other),
        React.createElement(DialogHeader, { withCloseButton: true, title: EMIRATESAIRMILESDIALOGTITLE }),
        React.createElement(DialogContent, null,
            React.createElement(Styler, { py: 5 },
                React.createElement(Stacker, { spacing: 6 },
                    React.createElement(TypographyBody, { size: "s" }, skywardsText))))));
}
